import React from 'react';

const SalesTimeline = () => {
  const salesData = [
    {
      month: "January",
      items: [
        { name: "Ultra Slim LED Display", qty: 15.00, revenue: 450.00 },
        { name: "prestige 1.5 l", qty: 3.00, revenue: 18600.00 },
        { name: "mango", qty: 1.00, revenue: 500.00 },
        { name: "SERVICE", qty: 1.00, revenue: 13000.00 },
        { name: "PEN", qty: 1.00, revenue: 12000.00 }
      ]
    },
    {
      month: "February",
      items: [
        { name: "elite EPS", qty: 15.00, revenue: 494.50 },
        { name: "PEN", qty: 12.00, revenue: 1144.00 },
        { name: "benetia", qty: 1.00, revenue: 1165.00 },
        { name: "prestige 1.5 l", qty: 1.00, revenue: 6200.00 },
        { name: "GAS 21 KG", qty: 1.00, revenue: 52000.00 }
      ]
    },
    {
      month: "March",
      items: [
        { name: "HP 12 COLOUR", qty: 100.00, revenue: 4500.00 },
        { name: "REAR SHOCK ABSORBER ETIOS", qty: 3.00, revenue: 45000.00 },
        { name: "prestige 1.5 l", qty: 2.00, revenue: 12400.00 },
        { name: "CABINET", qty: 1.00, revenue: 16600.00 },
        { name: "FRONT BUMPER", qty: 1.00, revenue: 11400.00 }
      ]
    },
    {
      month: "April",
      items: [
        { name: "REAR SHOCK ABSORBER ETIOS", qty: 2.00, revenue: 32500.00 },
        { name: "PEN", qty: 1.00, revenue: 112.00 },
        { name: "SERVICE", qty: 1.00, revenue: 15000.00 },
        { name: "prestige 1.5 l", qty: 1.00, revenue: 114.00 }
      ]
    },
    {
      month: "May",
      items: [
        { name: "prestige 1.5 l", qty: 12.00, revenue: 74400.00 },
        { name: "Ultra Slim LED Display", qty: 15.00, revenue: 429000.00 },
        { name: "elite EPS", qty: 1.00, revenue: 494.50 },
        { name: "mango", qty: 1.00, revenue: 500.00 },
        { name: "GAS 21 KG", qty: 1.00, revenue: 52000.00 }
      ]
    },
    {
      month: "June",
      items: [
        { name: "Seventh Genitis", qty: 130.00, revenue: 25500.00 },
        { name: "PEN", qty: 200.00, revenue: 24600.00 },
        { name: "ULTRA SLIM Connect 55Kg", qty: 1.00, revenue: 45000.00 },
        { name: "INDIAN CLOSET", qty: 1.00, revenue: 750700.00 },
        { name: "prestige 1.5 l", qty: 1.00, revenue: 6200.00 }
      ]
    },
    {
      month: "December",
      items: [
        { name: "prestige 1.5 l", qty: 1.00, revenue: 6235800.00 },
        { name: "GAS 21 KG", qty: 1.00, revenue: 52000.00 }
      ]
    }
  ];

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const timelineStyle = {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f5f5f5',
    padding: '20px',
    minHeight: '100vh'
  };

  const headerStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '30px',
    textAlign: 'left'
  };

  const timelineContainerStyle = {
    position: 'relative',
    maxWidth: '1000px',
    margin: '0 auto'
  };

  const timelineLineStyle = {
    position: 'absolute',
    left: '50%',
    top: '0',
    bottom: '0',
    width: '4px',
    backgroundColor: '#8b5fbf',
    transform: 'translateX(-50%)',
    zIndex: 1
  };

  const monthContainerStyle = {
    display: 'flex',
    marginBottom: '40px',
    position: 'relative'
  };

  const monthCardStyle = {
    backgroundColor: 'white',
    border: '2px solid #8b5fbf',
    borderRadius: '8px',
    padding: '15px',
    minWidth: '300px',
    maxWidth: '400px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    position: 'relative',
    zIndex: 2
  };

  const monthHeaderStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#8b5fbf',
    marginBottom: '15px',
    textAlign: 'center'
  };

  const itemStyle = {
    borderBottom: '1px solid #e0e0e0',
    padding: '8px 0',
    fontSize: '12px'
  };

  const itemNameStyle = {
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '2px'
  };

  const itemDetailsStyle = {
    color: '#666',
    fontSize: '11px'
  };

  const connectorStyle = {
    position: 'absolute',
    top: '50%',
    width: '20px',
    height: '4px',
    backgroundColor: '#8b5fbf',
    zIndex: 2
  };

  return (
    <div style={timelineStyle}>
      <div style={headerStyle}>SALES TIMELINE</div>
      <div style={timelineContainerStyle}>
        <div style={timelineLineStyle}></div>
        
        {salesData.map((monthData, index) => {
          const isLeft = index % 2 === 0;
          
          const containerStyle = {
            ...monthContainerStyle,
            justifyContent: isLeft ? 'flex-start' : 'flex-end'
          };

          const cardStyle = {
            ...monthCardStyle,
            marginLeft: isLeft ? '0' : 'auto',
            marginRight: isLeft ? 'auto' : '0'
          };

          const connector = {
            ...connectorStyle,
            left: isLeft ? 'calc(50% - 20px)' : '50%',
            transform: 'translateY(-50%)'
          };

          return (
            <div key={monthData.month} style={containerStyle}>
              <div style={connector}></div>
              <div style={cardStyle}>
                <div style={monthHeaderStyle}>{monthData.month}</div>
                {monthData.items.map((item, itemIndex) => (
                  <div key={itemIndex} style={itemStyle}>
                    <div style={itemNameStyle}>{item.name}</div>
                    <div style={itemDetailsStyle}>
                      Qty Sold: {item.qty.toFixed(2)}
                    </div>
                    <div style={itemDetailsStyle}>
                      Revenue: {formatCurrency(item.revenue)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SalesTimeline;